export default __webpack_public_path__ + "static/media/Dreamweaver.8e69be12.png";